<template>
  <b-form-group
    :label="label"
  >
    <v-select
      :name="name"
      :value="optionSelected"
      :options="listOptions"
      :class="{ 'v-select-danger': danger, 'select-size-sm': small }"
      :disabled="isDisabled"
      @input="onInput"
      :placeholder="placeholder"
    >
      <template #spinner>
        <b-spinner
          small
          v-if="documentProcessState.loading"
          :style="{ opacity: documentProcessState.loading ? 1 : 0 }"
          variant="primary"
        />
      </template>
      <template slot="no-options">
        no hay tipos de documentos para el criterio de búsqueda
      </template>
    </v-select>
    <div
      v-if="danger"
      class="con-text-validation span-text-validation-danger v-enter-to"
      style="height: 19px;">
      <span class="span-text-validation">
        {{ dangerText }}
      </span>
    </div>
  </b-form-group>
</template>

<script>

import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('List', [
      'documentProcessState'
    ]),
    optionSelected() {
      return this.documentProcessState.list.find((option) => option.value === this.value);
    },
    isDisabled() {
      return this.disabled
        || !this.documentProcessState.list.length
        || this.documentProcessState.loading;
    },
    listOptions() {
      return this.documentProcessState.list;
    }
  },
  methods: {
    ...mapActions('List', [
      'fetchDocumentProcess'
    ]),
    onInput(event) {
      this.$emit('input', event?.value);
      this.$emit('change', event?.value);
      this.$emit('get-option-id', event?.id);
    },
    getOption() {
      return this.documentProcessState.list.find((option) => option.value === this.value);
    }
  },
  created() {
    this.fetchDocumentProcess({ company: this.companyToLoad, group: this.group });
  },
  props: {
    name: { type: String, required: true },
    label: { type: String, default: 'Tipo Documento' },
    group: { type: String, default: 'procesos-siss' },
    value: { type: String },
    danger: { type: Boolean },
    dangerText: { type: String },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: true },
    small: { type: Boolean, default: false },
    typeNumeration: { type: String },
    companyToLoad: {
      type: String,
      required: false,
      default: null
    },
    placeholder: { type: String }
  }
};

</script>
